import React from 'react';
import CrudTable from '../../components/CrudTable';
import Title from '../../components/Title';
import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { normalizeBool } from '../../utils/functions';
import { ISegmento } from '../../AppContext';
import exportFromJSON from 'export-from-json';
import moment from 'moment';
import { Spinner, SpinnerSize } from '@fluentui/react';

const Segmentos = () => {
	const addQuery = gql`mutation($descripcion: String!){
		setSegmento(
		  input:{
			Descripcion: $descripcion
		  }
		){
			UUID
			Descripcion
			Error
		}
	}`;
	const setQuery = gql`mutation($currId: String!, $descripcion: String!){
		setSegmento(
		  input:{
			UUID: $currId
			Descripcion: $descripcion
		  }
		){
			UUID
			Descripcion
			Error
		}
	}`;

	const deleteQuery = gql`mutation($currId: String!){
		deleteSegmento(
		  input:{
			UUID: $currId
		  }
		){
			Completed
			Error
		}
	}`;


	const getQuery = gql`query {
		getSegmento{
			UUID
			Descripcion
			hasCadenas
		}
	}`;

	const { data, refetch, loading: getLoading } = useQuery(getQuery);

	const source = { 
		datafields: [
			{ name: 'UUID', type: 'string', readonly: true },
			{ name: 'Descripcion', type: 'string' },
			{ name: 'hasCadenas', type: 'bool', readonly: true }
		],
		datatype: 'json',
		root: '',
		id:'UUID',
		localdata: data
	}
	const columns = [
		{ text: 'Descripción', datafield: 'Descripcion'},
		{ text: 'Cadenas', datafield: 'hasCadenas', cellsRenderer: (_r:any,_c:any,val:any)=>{return normalizeBool(val)}}
	]

	const [getData, { loading }] = useLazyQuery(getQuery, {
		fetchPolicy: "no-cache",
		onCompleted: fetchedData => {

			const data:any[] = []
			fetchedData.getSegmento.forEach((segmento:ISegmento)=>{
				let s = {
					"Descripción": segmento.Descripcion,
					"Cadenas": segmento.hasCadenas?"Sí":"No"
				}
				data.push(s)
			})
			exportFromJSON({
				data: data,
				exportType: exportFromJSON.types.xls,
				fileName: `${moment().format('YYYY-MM-DD hh-mm-ss')} - Segmentos`,
			})
		}
	});

	let isLoading = loading || getLoading
	
	return(
		<>
			<Title title={"Segmentos"}/>
			{isLoading && <div className="spinner-container small"><Spinner size={SpinnerSize.medium} /></div>}
			<div className={`table-container small ${isLoading?"loading":""}`}>
			<CrudTable
				label={"Segmento"}
				itemName={"Segmento"}
				items={data}
				source={source}
				columns={columns}
				width={60}
				addQuery={addQuery}
				setQuery={setQuery}
				deleteQuery={deleteQuery}
				refetch={refetch}
				exportFunc={getData}
			/>
			</div>
		</>
	)
}

export default Segmentos;